'use strict';
var toString = require('../internals/to-string');

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/normalize-string-argument.js
// module id = 134
// module chunks = 0